export interface EmailTemplates {
    newPrescription : EmailTemplate;
    refill: EmailTemplate;
    medSyncReminder: EmailTemplate;
}

export class EmailTemplates {
    constructor(obj?: EmailTemplates) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}

export interface EmailTemplate {
    active: boolean;
    templateId: string;
    fromEmail: string;
    asmGroup?: number;
}

export class EmailTemplate {
    constructor(obj?: EmailTemplate) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
}
